import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { RecordContextProvider, useRecordContext } from 'react-admin';
import RuleLogic from '../components/steps/RuleLogic';
import RuleTriggers from '../components/steps/RuleTriggers';
import RuleResponse from '../components/steps/RuleResponse';
import RuleScore from '../components/steps/RuleScore';
import RuleSummary from '../components/steps/ruleSummary';

import FormWizard from '../../layout/formWizard/FormWizard';
import { usePendingReviewBlocked } from '../../../context/PendingReviewContext';

const OngoingRules = () => {
  const createPing = useWatch({ name: 'createPing', defaultValue: true });
  const record = useRecordContext();
  const { getValues } = useFormContext();

  const pendingReview = usePendingReviewBlocked();
  const isDraft = !record?.versions?.length;
  const isEditable = isDraft && !pendingReview;

  return (
    <FormWizard
      edit={isEditable}
      formPaths={[
        {
          path: '',
          label: 'Rule logic',
          element: <RuleLogic />,
        },
        {
          path: 'triggers',
          label: 'Rule triggers',
          element: <RuleTriggers />,
        },
        {
          path: 'response',
          label: 'Rule response',
          element: <RuleResponse />,
        },
        {
          path: 'score',
          label: 'Score calculation',
          element: <RuleScore />,
          hidden: !createPing,
        },
        {
          path: 'summary',
          label: 'Summary',
          element: (
            <RecordContextProvider value={getValues()}>
              <RuleSummary />
            </RecordContextProvider>
          ),
        },
      ]}
    />
  );
};

export default OngoingRules;
